import type {SVGProps} from 'react'

const SvgAdmin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 24 24'}
    {...props}
  >
    <circle
      cx={12}
      cy={7.5}
      r={3.5}
      stroke={'currentColor'}
      strokeWidth={1.25}
    />
    <path
      stroke={'currentColor'}
      strokeWidth={1.25}
      d={'M5 20v-2.5A3.5 3.5 0 0 1 8.5 14H12M14.5 14.5l2.408-.876a1 1 0 0 1 .684 0L20 14.5v2.673c0 .212-.067.42-.203.583-.39.472-1.315 1.497-2.547 2.244-1.232-.747-2.157-1.772-2.547-2.244a.9.9 0 0 1-.203-.583z'}
    />
  </svg>
)
export default SvgAdmin
